import React from 'react';
import { Col } from 'antd';
import { EarlyManifestationFormItem } from '@/components/views/Resolution886/components/Form';

export function EarlyManifestation(): JSX.Element {
	return (
		<Col xs={24}>
			<EarlyManifestationFormItem fieldName="early_manifestation" required={false} />
		</Col>
	);
}
